// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__YersL","filesListContainer":"PosDisputesFiles_filesListContainer__YkTyr","filesButton":"PosDisputesFiles_filesButton__1k9RE"};